/* eslint-disable jsx-a11y/anchor-is-valid */
import { Doughnut } from 'react-chartjs-2';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import ChartDataLabels from 'chartjs-plugin-datalabels';

export function Dashboard2(props: any) {
    const { dataSource } = props

    const doughnutOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            scales: {
                xAxes: [{
                    gridLines: {
                        display: false
                    }
                }],
                yAxes: [{
                    gridLines: {
                        display: false
                    }
                }]
            },
            title: {
                display: true,
                text: 'จำนวนผู้ใช้และจำนวนข้อความ',
                font: {
                    size: 16
                }
            },
            legend: {
                display: false,
            },
            datalabels: {
                anchor: 'center',
                color: 'black',
                labels: {
                    title: {
                        font: {
                            weight: 'bold'
                        }
                    },
                    value: {
                        color: 'green'
                    }
                }
            }
        },
    };

    const doughnutData: any = {
        labels: dataSource.labels,
        datasets: [
            {
                label: dataSource.datasets[0].label,
                data: dataSource.raw_data,
                backgroundColor: [
                    '#26A65B',
                    'red',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (<Doughnut
        data={doughnutData}
        options={doughnutOptions}
        width={350}
        height={350}
        plugins={[ChartDataLabels]}
    />)

}